import type { ChangeWheelsView } from "@slfinrtl/ui-bff-routes"
import { useEffect } from "react"
import type { UseFormReturn } from "react-hook-form"
import { useForm } from "react-hook-form"
import type { ChangeSelectedWheelsForm } from "src/hooks"
import { customWheelsOptionCode } from "src/hooks"

export const useChangeSelectedWheelsForm: (props: {
	view: ChangeWheelsView["selected"]
}) => UseFormReturn<ChangeSelectedWheelsForm> = ({ view }) => {
	const form = useForm<ChangeSelectedWheelsForm>({
		defaultValues: {
			optionCode: "",
		},
	})

	useEffect(() => {
		form.reset(
			{
				optionCode: view.option.optionCode === null ? customWheelsOptionCode : (view.option.optionCode ?? ""),
			},
			{ keepFieldsRef: true },
		)
	}, [view, form])

	return form
}
